import BoxInfo from '@/components/boxInfo/boxInfo';
import IconBenefit from '@/components/iconBenefit';
import TextData from '@/components/textData/textData';
import { BeneficiaryNormalized } from '@/modules/beneficiary/entities/interfaces';
import { BenefitSlugType } from '@/modules/benefit/entities/types/benefit';
import { Contract } from '@/modules/contract/entities/interfaces/contract';
import { Negotiation } from '@/modules/negotiation/entities/interfaces/negotiation';
import { get } from 'lodash';
import React from 'react';
import slugify from 'slugify';
import { LogoProvider } from '@/modules/provider';
import { isOmni } from '@/pages/beneficiaries/shared/utils/checkProvider';

interface BenefitDataProps {
  title?: string;
  icon?: string;
  negotiation?: Negotiation;
  beneficiary?: BeneficiaryNormalized;
}

const { REACT_APP_ENROLLMENT_CODE_DEFAULT } = process.env;

const BenefitData: React.FC<BenefitDataProps> = ({
  title = 'Dados do benefício',
  icon = 'activity-outline',
  negotiation,
  beneficiary,
}) => {
  const product = get(negotiation, 'product', { name: '', providerInternalCode: '' });
  const provider = get(negotiation, 'product.provider');
  const benefit = get(negotiation, 'product.benefit');
  const contract = get(negotiation, 'contract', { code: '' }) as Contract;
  const costCenter = get(negotiation, 'costCenter', { name: '' });

  return (
    <BoxInfo title={title} icon={icon}>
      <TextData
        loading={false}
        data={[
          {
            label: 'Fornecedor',
            text: provider?.name,
            component: provider?.cnpj ? (
              <LogoProvider size='small' providerCnpj={String(provider.cnpj)} />
            ) : null,
            sizeMobile: 100,
            sizeMedium: 100,
            sizeDefault: 66.66,
          },
          {
            label: 'Benefício',
            text: benefit?.name,
            component: (
              <IconBenefit
                small
                benefitSlug={slugify(benefit?.name || '', { lower: true }) as BenefitSlugType}
              />
            ),
            sizeMobile: 100,
            sizeMedium: 100,
            sizeDefault: 33.33,
          },
          {
            label: 'Plano',
            text:
              negotiation && isOmni(negotiation)
                ? product.name
                : product.providerInternalCode || product.name,
          },
          {
            label: 'Código do contrato',
            text: contract?.code,
          },
          {
            label: 'Subfatura',
            text: costCenter?.name,
          },
          {
            label: 'Número do cartão',
            text: beneficiary?.healthCardNumber,
            sizeMobile: 100,
            sizeMedium: 100,
            sizeDefault: 25,
          },
          {
            label: 'Início da vigência',
            text: beneficiary?.validFrom,
            type: 'date',
            sizeMobile: 100,
            sizeMedium: 100,
            sizeDefault: 25,
          },
          {
            label: 'Fim da vigência',
            text: beneficiary?.validUntil || '',
            type: 'date',
            sizeMobile: 100,
            sizeMedium: 100,
            sizeDefault: 25,
          },
          {
            label: 'Código do angariador',
            text: contract?.enrollmentCode || REACT_APP_ENROLLMENT_CODE_DEFAULT,
            type: 'date',
            sizeMobile: 100,
            sizeMedium: 100,
            sizeDefault: 25,
          },
        ]}
      />
    </BoxInfo>
  );
};

export default BenefitData;
